import { SxProps, Theme } from "@mui/material";

export const headingStyles = (isMobile: boolean): SxProps<Theme> => ({
  fontSize: isMobile ? "20px" : "45px",
});

export const inputLabelStyles: SxProps<Theme> = {
  fontSize: "0.75rem",
  color: "#333",
  fontWeight: 400,
};
